import { endPoints } from 'api/';
import { CREATE_ATTRIBUTE } from 'actions/types';

/**
 * @description Creates attribute list or updates existing attribute list in one go.
 * @param {{}} attributes
 */
function create({ attributes }) {
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: CREATE_ATTRIBUTE,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        const attribute = await apiClient(
          endPoints.CREATE_ATTRIBUTE,
          attributes,
        );
        return attribute;
      },
    };
    dispatch(action);
  };
}

export default create;
